document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.ns-menu-toggle');
  const menu = document.querySelector('.ns-nav');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const variantData = root.querySelector('[data-variant-json]');
    const form = root.querySelector('[data-product-form]');
    if (!variantData || !form) return;

    const variants = JSON.parse(variantData.textContent);
    const selectors = [...root.querySelectorAll('[data-option-position]')];
    const idInput = form.querySelector('[name="id"]');
    const addButton = form.querySelector('[data-add-button]');
    const addLabel = form.querySelector('[data-add-label]');
    const price = root.querySelector('[data-product-price]');
    const formatZar = (cents) => new Intl.NumberFormat('en-ZA', {
      style: 'currency',
      currency: 'ZAR'
    }).format(cents / 100);

    const updateVariant = () => {
      const selected = selectors.map((select) => select.value);
      const variant = variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
      if (!variant) {
        addButton.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }

      idInput.value = variant.id;
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (price) {
        root.querySelectorAll('[data-flash-main]').forEach((el) => { el.dataset.amount = variant.price; });
        document.dispatchEvent(new CustomEvent('ns:prices'));
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      if (variant.featured_image) {
        const mainImage = root.querySelector('[data-main-product-image]');
        if (mainImage) mainImage.src = variant.featured_image.src;
      }
    };

    selectors.forEach((select) => select.addEventListener('change', updateVariant));
  });

  document.querySelectorAll('[data-product-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const root = button.closest('[data-product-root]');
      const mainImage = root && root.querySelector('[data-main-product-image]');
      if (!mainImage) return;
      mainImage.src = button.dataset.image;
      mainImage.alt = button.dataset.alt || '';
      root.querySelectorAll('[data-product-thumb]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });
});
